import React from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";


interface BrowserSideBar {
    drawerWidth:number,
    handleDrawerToggle:()=>void,
    drawer : JSX.Element,
    mobileOpen : boolean,
    container : any
}


export const BrowserSideBar = ({drawer,drawerWidth,handleDrawerToggle,mobileOpen,container} : BrowserSideBar) =>{

    return(
        <Box
            component="nav"
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
        >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
                {drawer}
            </Drawer>
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
                open
            >
                {drawer}
            </Drawer>
        </Box>
    )
}